$(function() {
  $(document).on('change', '#checkout_accept_terms', function(){
      if(this.checked) {
          $(".newsl_btn").prop("disabled", false);
      } else {
          $(".newsl_btn").prop("disabled", true);
      }
  });  

  $(document).on('change', '#checkout_accept_terms_chk', function(){
      if(this.checked) {
          $("#cartCheckout").prop("disabled", false);
      } else {
          $("#cartCheckout").prop("disabled", true);
      }
  }); 

  $(document).on('change', '#checkout_accept_terms_contact', function(){
      if(this.checked) {
          $("#submittMsg").prop("disabled", false);
      } else {
          $("#submittMsg").prop("disabled", true);
      }
  });  
});  